import { gql, useQuery, useMutation } from "@apollo/client";
import { useEffect, useState } from "react";
import { captureException } from "@sentry/react";
import { isEmail } from "validator";

import { getFirstSixDigits } from "modules/functions";
import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";
import MailingListEmailForm from "./MailingListEmailForm";
import SetAutoresponder from "./SetAutoresponder";

export default ({
  listId,
  responder,
  closeResponderModal,
  refetchMailingListData,
}) => {
  const [selectedResponder, setSelectedResponder] = useState(responder);
  const [selectionOpened, setSelectionOpened] = useState(false);
  const [setAutoresponderLoading, setSetAutoresponderLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  // Fetch data
  const GET_RESPONDERS_DATA = gql`
    query GetRespondersData {
      responderList {
        id
        name
      }
    }
  `;

  const { data, error } = useQuery(GET_RESPONDERS_DATA, {
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("error fetching responders data", error);
    captureException(error);
  }

  // handle Selection
  const toggleSelection = () => {
    setSelectionOpened((prevState) => !prevState);
  };

  const onSelectOption = (id) => {
    if (!data) return;

    const selected = data.responderList.find(
      (responder) => responder.id === id
    );

    if (selected) setSelectedResponder(selected);

    setSelectionOpened(false);
  };

  const SET_RESPONDER = gql`
    mutation SetResponder($listId: ID!, $responderId: ID!) {
      setResponder(listId: $listId, responderId: $responderId) {
        resultCode
      }
    }
  `;

  const [setResponder] = useMutation(SET_RESPONDER);

  const setAutoresponder = async () => {
    try {
      if (!data) return;
      if (setAutoresponderLoading) return;

      setErrorMessage(null);
      setSetAutoresponderLoading(true);

      const result = await setResponder({
        variables: {
          listId,
          responderId: selectedResponder.id,
        },
      });

      const { resultCode } = result.data.setResponder;
      console.log("resultCode", resultCode);

      setSetAutoresponderLoading(false);

      if (resultCode !== 0) {
        setErrorMessage(
          "An error occurred while submitting the request. Please try again or contact support."
        );

        return;
      }

      refetchMailingListData();
      closeResponderModal();
    } catch (error) {
      console.log("error setAutoresponder", error);
      captureException(error);
      setSetAutoresponderLoading(false);
      return;
    }
  };

  console.log("data", data);
  console.log("selectedResponder", selectedResponder);

  return (
    <>
      {!data && (
        <LoadingBox>
          <BoxLoadingSpinner height="250px" />
        </LoadingBox>
      )}
      {data && (
        <SetAutoresponder
          data={data}
          selectionOpened={selectionOpened}
          selectedResponder={selectedResponder}
          toggleSelection={toggleSelection}
          onSelectOption={onSelectOption}
          setAutoresponder={setAutoresponder}
          setAutoresponderLoading={setAutoresponderLoading}
          errorMessage={errorMessage}
          listId={listId}
        />
      )}
    </>
  );
};
